import { app } from '../../../../../app';
import { Controller } from './hard-token-registration.controller';

app.component('editHardTokenRegistration', {
   bindings: {
        companyId: '<',
        token: '=',
        regEmailData: '<'
    },
    controller: Controller,
    templateUrl: require('./hard-token-registration.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-edit/registration/hard-token-registration.component.js